import React from 'react';
import AntButton from 'components/AntButton/AntButton';

const getErrorMessage = error =>
	error?.message ||
	(typeof error === 'string'
		? error
		: 'Intente nuevamente en unos momentos.');

const OrderOverviewLoadError = ({ error, onRetry }) => (
	<div role='alert' data-testid='order-overview-error'>
		<strong>No se pudo cargar el overview de la orden</strong>
		<p>{getErrorMessage(error)}</p>
		<AntButton
			size='small'
			onClick={onRetry}
			aria-label='Reintentar carga del overview de la orden'
		>
			Reintentar
		</AntButton>
	</div>
);

export default OrderOverviewLoadError;
